import React, { useState, useEffect, useCallback } from 'react';
import { Box } from '@mui/material';
import DashboardLayout from './DashboardLayout';
import AccountManagementPage from './Account/AccountManagement';
import KycDocsUpload from './Account/KYCUpload';
import NationalIDUpload from './Account/NationalIDUpload';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PageLoader from '../../../Reusable/PageLoader'; // <-- import PageLoader
import baseURL from '../../user/config';

const AccountManagement = () => {
    const [profileData, setProfileData] = useState(null);
    const [kycData, setKycData] = useState(null);
    const [nationalIdData, setNationalIdData] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            // await new Promise(resolve => setTimeout(resolve, 4000));

            // Fetch all data concurrently
            const [profileResponse, kycResponse, nationalIdResponse] = await Promise.all([
                fetch(`${baseURL}/org/all/profile`, { credentials: 'include' }),
                fetch(`${baseURL}/org/check-kyc`, { credentials: 'include' }),
                fetch(`${baseURL}/org/my-uploads`, { credentials: 'include' })
            ]);

            const profileResult = await profileResponse.json();
            if (!profileResponse.ok) throw new Error(profileResult.message || 'Failed to fetch user profile.');
            setProfileData(profileResult.profile);

            if (kycResponse.ok) {
                const kycResult = await kycResponse.json();
                setKycData(kycResult.data);
            } else if (kycResponse.status === 404) {
                setKycData(null);
            } else {
                throw new Error('Failed to fetch KYC data.');
            }

            if (nationalIdResponse.ok) {
                const nationalIdResult = await nationalIdResponse.json();
                setNationalIdData(nationalIdResult.data);
            } else if (nationalIdResponse.status === 404) {
                setNationalIdData(null);
            } else {
                throw new Error('Failed to fetch National ID data.');
            }
        } catch (err) {
            console.error('Data fetching error:', err);
            toast.error(err.message || 'Failed to load account data');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <DashboardLayout>
            {loading && <PageLoader />} {/* Loader inside layout */}

            {!loading && profileData && (
                <>
                    <AccountManagementPage
                        userProfile={profileData}
                        onDataUpdated={fetchData}
                    />
                    <KycDocsUpload 
                        userProfile={profileData}
                        kycData={kycData}
                        onDataUpdated={fetchData} 
                    />
                    <NationalIDUpload 
                        userRole={profileData.role}
                        nationalIdData={nationalIdData}
                        onDataUpdated={fetchData}
                    />
                </>
            )}
        </DashboardLayout>
    );
};

export default AccountManagement;
